import { render, staticRenderFns } from "./SdmWeb.vue?vue&type=template&id=06f14320&scoped=true&"
import script from "./SdmWeb.vue?vue&type=script&lang=js&"
export * from "./SdmWeb.vue?vue&type=script&lang=js&"
import style0 from "./SdmWeb.vue?vue&type=style&index=0&id=06f14320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f14320",
  null
  
)

export default component.exports